import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import SeoHead from '../../shared/components/SeoHead.jsx';
import LangToggle from '../../shared/components/LangToggle.jsx';
import { useT } from '../../shared/lib/useT.js';

export default function Landing() {
  const { t, lang } = useT();
  const fr = lang === 'fr';

  return (
    <main className="landing">
      <Helmet>
        <link
          rel="preload"
          as="image"
          href="/hero-polo.avif"
          type="image/avif"
          fetchpriority="high"
        />
      </Helmet>
      <SeoHead
        title={t('meta.landing.title')}
        description={t('meta.landing.description')}
      />

      <header className="landing-nav">
        <div className="landing-nav-inner">
          <Link to={fr ? '/fr' : '/'} className="landing-wordmark">
            ETSEM MEDIA
          </Link>
          <nav className="landing-nav-links">
            <Link
              to="/dashboard"
              className="landing-nav-link landing-nav-login"
            >
              {t('nav.login')}
            </Link>
            <LangToggle />
          </nav>
        </div>
      </header>

      <section className="hero hero-split">
        <div className="hero-text">
          <div className="hero-text-inner">
            <div className="eyebrow">{t('hero.eyebrow')}</div>
            <h1 className="hero-title">{t('hero.title')}</h1>
            <p className="hero-sub">{t('hero.subtitle')}</p>
            <a href="#contact" className="cta">
              {t('hero.cta')}
            </a>
          </div>
        </div>
        <div className="hero-photo" aria-hidden="true" />
      </section>

      <section className="section" id="about">
        <div className="container">
          <div className="eyebrow">{t('about.eyebrow')}</div>
          <p className="lede">{t('about.lede')}</p>
          <p>{t('about.p2')}</p>
          <p>{t('about.p3')}</p>
        </div>
      </section>

      <section className="section section-accent" id="vision">
        <div className="container">
          <div className="eyebrow">{t('vision.eyebrow')}</div>
          <blockquote className="pullquote">{t('vision.quote')}</blockquote>
          <p>{t('vision.body')}</p>
        </div>
      </section>

      <section className="section" id="platform">
        <div className="container">
          <div className="eyebrow">{t('platform.eyebrow')}</div>
          <h2>{t('platform.title')}</h2>
          <p className="lede">{t('platform.lede')}</p>
          <p>{t('platform.p2')}</p>
          <blockquote className="pullquote pullquote-tight">
            {t('platform.quote')}
          </blockquote>
        </div>
      </section>

      <section className="section section-accent" id="mimir">
        <div className="container">
          <div className="eyebrow">{t('mimir.eyebrow')}</div>
          <h2>{t('mimir.title')}</h2>
          <p className="lede">{t('mimir.lede')}</p>
          <p>{t('mimir.p2')}</p>

          <div className="features">
            {['access', 'ai', 'edit', 'review', 'delivery', 'liveu', 'spx'].map(
              (key) => (
                <article key={key} className="feature">
                  <h3>{t(`mimir.features.${key}.title`)}</h3>
                  <p>{t(`mimir.features.${key}.body`)}</p>
                </article>
              )
            )}
          </div>
        </div>
      </section>

      <section className="section" id="unlocks">
        <div className="container">
          <div className="eyebrow">{t('unlocks.eyebrow')}</div>
          <h2>{t('unlocks.title')}</h2>

          <div className="unlocks">
            {['documentary', 'monetization', 'realtime', 'storytelling'].map(
              (key) => (
                <article key={key} className="unlock">
                  <h3>{t(`unlocks.items.${key}.title`)}</h3>
                  <p>{t(`unlocks.items.${key}.body`)}</p>
                </article>
              )
            )}
          </div>
        </div>
      </section>

      <section className="contact-section" id="contact">
        <div className="contact-split">
          <div className="contact-side-text">
            <div className="contact-text-inner">
              <div className="eyebrow">{t('contact.eyebrow')}</div>
              <img
                src="/didier-lahaye.jpg"
                alt={t('contact.name')}
                className="contact-portrait-mobile"
                width="140"
                height="140"
                loading="lazy"
                decoding="async"
              />
              <div className="contact-name-xl">{t('contact.name')}</div>
              <div className="contact-title">{t('contact.role')}</div>
              <a
                href="mailto:DidierLahaye@etsem.com"
                className="contact-email-xl"
              >
                DidierLahaye@etsem.com
              </a>
              <div className="contact-location">{t('contact.location')}</div>
            </div>
          </div>
          <div className="contact-side-photo" aria-hidden="true" />
        </div>
      </section>

      <footer className="landing-foot">
        <div className="foot-tag">{t('footer.tagline')}</div>
        <Link to={fr ? '/fr/legal' : '/legal'} className="foot-legal">
          {t('footer.legal')}
        </Link>
      </footer>
    </main>
  );
}
